export default {
      id: "posted-speed-limit-report-usage",
      viewBox: "0 0 44 26",
      url: __webpack_public_path__ + "img/icons.svg#posted-speed-limit-report",
      toString: function () {
        return this.url;
      }
    }